import { images } from '../data/content'

/**
 * Image loading strategy.
 *
 * The hero <img> already carries fetchpriority="high", so the browser starts it
 * as soon as React mounts. Requesting the same URL here means the file is on the
 * wire the moment the app boots, and the copy rendered in the buy section hits a
 * warm cache instead of a second download.
 */
declare global {
  interface Window {
    __imagesPreloaded?: boolean
  }
}

export function preloadImages() {
  if (typeof window === 'undefined' || window.__imagesPreloaded) return
  window.__imagesPreloaded = true

  const hero = new Image()
  hero.src = images.heroTablets
}
